<div mat-dialog-content class="body">
  @if (!data.step) {
  <div class="close-icon">
    <img alt="" (click)="onClose()" src="../../../../../../assets/checkout-icons/x-black-icon.svg" />
  </div>
  } @if (!msg) {
  <div class="body__title">
    We Found <b>{{ citiesCount }}</b> {{citiesOrStreetsMsg}} <br /><br />
    <div (click)="getCitiesList($event)" style="text-decoration: underline; cursor: pointer">
      Get List of {{citiesOrStreetsMsg}}
    </div>
  </div>
  } @if (msg) {
  <div class="body__title">{{ msg }}</div>
  } @if (data.step) {
  <div class="body__actions">
    <pdq-button variant="light" (onClick)="onDeliveryMethodDiscard()">Yes, leave</pdq-button>
    <pdq-button variant="dark" (onClick)="onDeliveryMethodRelease()">No, stay</pdq-button>
  </div>
  }
</div>
